module.exports = __webpack_public_path__ + "img/carousel-clientes-17.4995c772.png";